import React from 'react'
import { Avatar, Card, Container } from '@material-ui/core'
import Stack from '@mui/material/Stack';
import { useParams } from 'react-router-dom';

import useStyles from './style'

export const Profile = () => {
    const classes=useStyles();
    const id=useParams();
    console.log(id)
    //const theme=useTheme();
    //const isMatch=useMediaQuery(theme.breakpoints.down('md'));
    
  return (
    <div>
    <Container fixed>
        <Card className={classes.Top} >
        <Stack direction="row" spacing={2}>
            <Avatar className={classes.profile}>M</Avatar>        
        </Stack>
                         
                   
        </Card>
    </Container>

    </div>
  )
}
